import { Data_getInstance1bw72swqgx6r7 as Data_getInstance } from './adapter/DeleteSecretMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { DeleteSecretMutationSelections_getInstance1gjquo03jqhml as DeleteSecretMutationSelections_getInstance } from './selections/DeleteSecretMutationSelections.mjs';
import { DeleteSecretMutation_VariablesAdapter_instance27fc2ttxdnf7e as DeleteSecretMutation_VariablesAdapter_instance } from './adapter/DeleteSecretMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(deleteSecret) {
        this.deleteSecret_1 = deleteSecret;
      }
      toString() {
        return 'Data(deleteSecret=' + this.deleteSecret_1 + ')';
      }
      hashCode() {
        return this.deleteSecret_1 == null ? 0 : getBooleanHashCode(this.deleteSecret_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.deleteSecret_1 == other.deleteSecret_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.ADAPTER_1 = obj(Data_getInstance());
        this.ROOT_FIELD_1 = (new (Builder())('data', Companion_getInstance().type_1)).selections_gjxob8_k$(DeleteSecretMutationSelections_getInstance().__root_1).build_1k0s4u_k$();
        this.OPERATION_ID_1 = '5a55c69595e1569210aeaa4dfc459e9c525775865fce9c5a8fbfdc346149c2c8';
        this.OPERATION_NAME_1 = 'deleteSecret';
      }
      get_OPERATION_DOCUMENT_t250nw_k$() {
        return 'mutation deleteSecret($input: DeleteSecretInput!) { deleteSecret(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var DeleteSecretMutationClass;
function DeleteSecretMutation() {
  if (DeleteSecretMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.input_1 = input;
      }
      operationId_2580de_k$() {
        return '5a55c69595e1569210aeaa4dfc459e9c525775865fce9c5a8fbfdc346149c2c8';
      }
      operationId() {
        return this.operationId_2580de_k$();
      }
      document_e91o2j_k$() {
        return Companion_getInstance_0().get_OPERATION_DOCUMENT_t250nw_k$();
      }
      operationName_1injiq_k$() {
        return 'deleteSecret';
      }
      operationName() {
        return this.operationName_1injiq_k$();
      }
      serializeVariables_bugef7_k$(writer, customScalarAdapters, withDefaultValues) {
        DeleteSecretMutation_VariablesAdapter_instance.serializeVariables_ae77ue_k$(writer, this, customScalarAdapters, withDefaultValues);
      }
      adapter_j0zdtd_k$() {
        return Companion_getInstance_0().ADAPTER_1;
      }
      toString() {
        return 'DeleteSecretMutation(input=' + this.input_1.toString() + ')';
      }
      hashCode() {
        return this.input_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeleteSecretMutation()))
          return false;
        if (!this.input_1.equals(other.input_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeleteSecretMutation', VOID, VOID, [Mutation()]);
    DeleteSecretMutationClass = $;
  }
  return DeleteSecretMutationClass;
}
//region block: exports
export {
  Data as Data19yd1q1ikzzyl,
  DeleteSecretMutation as DeleteSecretMutation2wndasm4ltzuw,
};
//endregion

//# sourceMappingURL=DeleteSecretMutation.mjs.map
